// extracted by mini-css-extract-plugin
module.exports = {"ComponentHolder":"BurgerMenuTitle_ComponentHolder__3aq2B"};